import i18n from 'i18n';
import { ResourceType } from 'shared/interfaces/Resource';
import { SmartAssistantType } from 'shared/interfaces/SmartAssistant';

export const MY_RESOURCES_FILTER = i18n.t('ORGANISATION.TEAMS.RESOURCE_TEAM_FILTER.CREATED_BY_ME');

const DEFAULT_RESOURCE_TYPES = [
  ResourceType.GOOGLE_DRIVE,
  ResourceType.TEXT,
  ResourceType.WEB,
  ResourceType.YOUTUBE,
  ResourceType.PDF,
  ResourceType.VIDEO
];

// We could eventually create a configuration file for different resource types.
// We could use it to specify allowed resources, allowed tools, etc.
// Specify only if different from the default ones.
export const ALLOWED_RESOURCE_TYPES = new Map<SmartAssistantType, ResourceType[]>([]);

export const getAllowedResourceTypes = (type: SmartAssistantType) => {
  return ALLOWED_RESOURCE_TYPES.get(type) ?? DEFAULT_RESOURCE_TYPES;
};
